export const SETTINGS_ROUTE_NAMES = Object.freeze({
  ACCOUNT_OWNER_SETTINGS: 'account-owner-settings',
  ADD_USER: 'company-add-user',
  APPLICATIONS: 'applications',
  BILLING: 'billing',
  BILLING_DUE: 'billing-due',
  BRAND_OWNER_SETTINGS: 'brand-owner-settings',
  BRAND_OWNER_BRANDS: 'brand-owner-brands',
  BRANDS: 'brands',
  BRAND_ADD: 'brand-add',
  BRAND_EDIT: 'brand-edit',
  BUYER_NOTIFICATIONS: 'buyer-notifications',
  BUYER_NOTIFICATIONS_LEGACY: 'buyer-notifications-legacy',
  BUYER_REGISTER_STORE: 'buyer-register-store',
  BUYER_SETTINGS_ACCOUNT_DETAILS: 'buyer-settings-account-details',
  DELIVERY_PROVIDER_SETTINGS: 'delivery-provider-settings',
  DEVELOPER_SETTINGS: 'developer-settings',
  EMAILS: 'emails',
  INFO: 'info',
  INTEGRATIONS: 'integrations',
  INTEGRATIONS_SELLER: 'integrations-seller',
  INTEGRATIONS_SELLER_CUSTOMER_MAPPING: 'integrations-seller-customer-mapping',
  INTEGRATIONS_SELLER_PRODUCT_MAPPING: 'integrations-seller-product-mapping',
  INVITE_USER: 'company-invite-user',
  INVOICE: 'invoice',
  LICENSES: 'licenses',
  LICENSES_INTEGRATION_ONBOARDING: 'licenses-integration-onboarding',
  LICENSES_DUE: 'licenses-due',
  ORDERS: 'orders',
  PAYMENTS_SETTINGS: 'payments-settings',
  PENDING_STORE_REQUESTS: 'pending-store-requests',
  REPORTS_SETTINGS: 'reports-settings',
  SELLER_SETTINGS_NEW: 'seller-settings-new',
  SELLER_GENERAL_SETTINGS: 'seller-general-settings',
  TAXES: 'taxes',
  USERS: 'users',
  EDIT_USERS: 'edit-users',
  FACILITY_MANAGEMENT: 'facilities',
});
